export default "__VITE_ASSET__DpElq$an__"